import { gql } from '@apollo/client';

export const MY_PROFILE_QUERY = gql`
  query MyProfile {
    myProfile {
      id
      name
      email
      role_id
      role {
        id
        role_type
      }
    }
  }
`;

export const USERS_QUERY = gql`
query Users {
  users {
    id
    name
    email
    role_id
    role {
      id
    }
  }
}
`;

export const ROLES_QUERY = gql`
query Roles {
  roles {
    id
    role_type
  }
}
`;

export const BASE_DATA_QUERY = gql`
  query BaseData {
    roles {
      id
      role_type
    }
    languages {
      id
      name
    }
  }
`;

export const CREATE_USER = gql`
  mutation CreateUser($user: AddUserInput!) {
      createUser(user: $user) {
        id
      }
    }
`;

export const UPDATE_USER = gql`
  mutation UpdateUser($updateUserId: Int!, $user: UpdateUserInput!) {
    updateUser(id: $updateUserId, user: $user) {
      id
    }
  }
`;

export const ORG_USER_QUERY = gql`
  query OrganizationUser {
    organizationUser {
      id
      user_id
      org_id
      is_org_admin
    }
  }
`;

export const UPDATE_MY_PROFILE = gql`
    mutation UpdateMyProfile($user: UpdateMyProfileInput!) {
      updateMyProfile(user: $user) {
        id
        name
        email
        role_id
        role {
          id
          role_type
        }
      }
    }

`;
